import React from 'react';
import '../../../index.css';

import ImagesPallet from '../../../utils/ImagesPallet';

const PriceCard = ({ title, price, features, picture, isPopular, borderColor = "" }) => {
  const getGlossyClass = () => {
    switch (borderColor) {
      case 'border-amber-700':
        return 'glossy-bronze';
      case 'border-gray-400':
        return 'glossy-silver';
      case 'border-slate-300':
        return 'glossy-platinum';
      case 'border-sky-400':
        return 'glossy-diamond';
      case 'border-purple-600':
        return 'glossy-private';
      default:
        return isPopular ? 'glossy-gold' : '';
    }
  };

  return (
    <div className={`bg-white rounded-lg shadow-lg p-8 w-full max-w-sm hover:shadow-2xl transform hover:scale-105 transition-all duration-300 relative ${isPopular ? `border-4 ${getGlossyClass()}` : borderColor ? `border-4 ${getGlossyClass()}` : ''}`}>
    {isPopular && (
      <div className="absolute top-0 right-0 bg-yellow-500 text-white px-3 py-1 rounded-bl-lg text-sm font-bold">
        POPULAR
      </div>
    )}
      <div className="grid grid-rows-2 justify-items-center items-center">
        {/* Image */}
        <div className="object-cover">
          <img src={picture} alt="Barber" />
        </div>

        {/* Content */}
        <div className="w-auto h-auto">
          <h2 className="text-2xl font-bold mb-4 text-gray-800 text-center">{title}</h2>
          <p className="text-3xl font-bold mb-6 mt-8 text-gray-600">{price}</p>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            {features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}


export default PriceCard;